module.exports = __webpack_public_path__ + "static/media/springbig-logo-white.64038ffa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/springbig-logo-white.svg
// module id = 2465
// module chunks = 0